import Big from 'big.js';

export const returnsToPercentage = (input: string | number) =>
  Big(input).times(100).toNumber();
